import axios from 'axios';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { t } from "i18next";
import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import yoga from "../../assets/images/onboarding/yoga.jpg";
import { setCurrentStatus, setMsisdn } from '../../redux/slice/guardSlice';

const BASE_URL = "https://wbilzss.tickhighs.com";
const SERVICE_ID = "WELLNESS";
// const SUB_SERVICE_ID = "HDaily";
// const CP_ID = "100";
// const CHANNEL = "wap";
// const COUNTRY = "SS";
// const OPERATOR = "ZAIN";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const countryCode = "211";

  const validationSchema = Yup.object({
    phoneNumber: Yup.string()
      .matches(/^\d+$/, t("validation.phoneNumber.numeric"))
      .min(7, t("validation.phoneNumber.minLength"))
      .max(9, t("validation.phoneNumber.maxLength"))
      .required(t("validation.phoneNumber.required"))
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    const msisdnFull = `${countryCode}${values.phoneNumber}`;
    dispatch(setMsisdn(values.phoneNumber));

    try {
      // Step 1: Check Subscription
      const checkRes = await axios.get(
        `${BASE_URL}/sub/checksub?msisdn=${msisdnFull}&serviceId=${SERVICE_ID}`
      );
      const checkData = checkRes.data;

      // If engine call failed
      if (checkData.responseCode !== "0") {
        navigate("/technical-error");
        return;
      }


      const currentStatus = checkData?.data?.currentStatus?.toLowerCase();
      dispatch(setCurrentStatus(currentStatus));

      // Step 2: Branch by currentStatus
      if (currentStatus === "active" || currentStatus === "demo") {
        // Active / Demo — Auth OTP flow (no subscription trigger)
        try {
          const otpRes = await axios.get(
            `${BASE_URL}/auth/otp/generate?msisdn=${msisdnFull}&language=_E`
          );

          if (otpRes.data.responseCode !== "0") {
            navigate("/technical-error");
            return;
          }
          navigate("/otpscreen");
        } catch {
          navigate("/technical-error");
        }

        

      } else if (
        currentStatus === "new" ||
        currentStatus === "unsub" ||
        currentStatus === "notsubscribed"
        
      ) {
        // New / Unsubscribed — Subscription OTP flow
        try {
          navigate("/subscription");
        } catch {
          navigate("/technical-error");
        }

      } else {
        navigate("/technical-error");
      }

    } catch {
      navigate("/technical-error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="inprogress">
      <div className="subsWrapper2">
        <div className="successBox">
          <img src={yoga} alt="wellness" className="img-fluid" style={{ width: "100%" }} />
        </div>
        <div className="subsWrapper">
          <div className="successCont">
            <h4>Wellness 360</h4>
            <Formik
              initialValues={{ phoneNumber: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, isValid, dirty }) => (
                <Form>
                  <label>{t("subscription.PhoneNumber")}</label>
                  <div className="inputWrap">
                    <span>{countryCode}</span>
                    <Field
                      type="text"
                      name="phoneNumber"
                      placeholder={t("subscription.phonePlaceholder")}
                      style={{ marginLeft: '8px' }}
                      maxLength={9}
                      onInput={(e) => { e.target.value = e.target.value.slice(0, 9); }}
                    />
                  </div>
                  <ErrorMessage
                    name="phoneNumber"
                    component="div"
                    className="error"
                    style={{ color: 'red', fontSize: 12 }}
                  />
                  <div className="plnaBtn">
                    <button
                      type="submit"
                      disabled={isSubmitting || !isValid || !dirty}
                      style={{
                        opacity: isSubmitting || !isValid || !dirty ? 0.5 : 1,
                        cursor: isSubmitting || !isValid || !dirty ? 'not-allowed' : 'pointer'
                      }}
                    >
                      {isSubmitting ? "Please wait..." : t("onboarding.continue")}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
